import { Box } from "@mui/material";
import ReportHeader from "../../pages/event/components/report/ReportHeader";
import TableComponentForReport from "../../pages/event/components/report/TableComponentForReports";
import ValueOrNoDataLabel from "./ValueOrNoDataLabel";
import ModalBackground from "./ModalBackground";
import localize from "../../common/localize";
import { useReactToPrint } from "react-to-print";
import { useRef } from "react";

export default function PrinterModal({
  show,
  setShow,
  modalTitle,
  reportTitle,
  reportSubtitle,
  columnHeaders,
  data,
  closeCallback,
}) {
  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    pageStyle: `@media print {
          @page {
            size: 600mm 500mm;
            margin: 0;
          }
          a[href]:after {
            content: none !important;
          }
        }`,
  });

  const getDataRows = () => {
    if (!data || data.length === 0) {
      return [];
    }

    const rows = data.map((cellValues, index) =>
      cellValues.map((cellValue, cellIndex) => (
        <ValueOrNoDataLabel
          key={`${index}_${cellIndex}`}
          data={cellValue}
          hideBackground
          centerValue
        />
      ))
    );

    return rows;
  };

  return (
    <ModalBackground
      paddingTopButton
      okButtonAlwaysAvailable
      title={modalTitle}
      showModal={show}
      setShowPrintModal={setShow}
      onClickToCancel={() => {
        setShow(false);
        closeCallback && closeCallback();
      }}
      onClickToSubmit={() => {
        handlePrint();
        closeCallback && closeCallback();
      }}
      cancelButtonText={localize.close}
      okButtonText={localize.print}
      Component={
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexFlow: "column",
            gap: "10px",
          }}
          ref={componentRef}
        >
          <ReportHeader customData={[reportTitle, reportSubtitle]} />
          <TableComponentForReport
            numbered
            headers={columnHeaders}
            rows={getDataRows()}
            bordered
            smallText
          />
        </Box>
      }
    />
  );
}
